:host {
  display: block;
}

.spw-separator {
  display: block;
  border-width: 1px;

  &--horizontal {
    border-bottom-style: solid;
    width: auto;
    height: 0;
  }

  &--vertical {
    border-right-style: solid;
    width: 0;
    height: auto;
  }

  &--dark {
    border-color: var(--spw-colors-support-grey-grey-900);
  }

  &--light {
    border-color: var(--spw-ds-white);
  }

  &--thickness-1 {
    border-width: 1px;
  }

  &--thickness-2 {
    border-width: 2px;
  }
}
